export default function (data, mergeInfo, outFileName, sheetName, options) {
  return new Promise((resolve, reject) => {
    import('xlsx').then((XLSX) => {
      const workBook = XLSX.utils.book_new()
      const workSheet = XLSX.utils.aoa_to_sheet(data)
      if (mergeInfo && mergeInfo.length) {
        workSheet['!merges'] = mergeInfo
      }
      if (options && options['!cols']) {
        workSheet['!cols'] = options['!cols']
      }
      if (options && options['!colFmt'] && options['!colFmt'].length) {
        const headRows = (options && options.headerRows) || 1
        const range = XLSX.utils.decode_range(workSheet['!ref'])
        const colFmts = options['!colFmt']
        colFmts.forEach((col) => {
          for (var row = range.s.r + headRows; row <= range.e.r; ++row) {
            var ref = XLSX.utils.encode_cell({ r: row, c: col.index })
            if (ref && workSheet[ref]) {
              workSheet[ref].t = col.dataType
            }
          }
        })
      }
      XLSX.utils.book_append_sheet(workBook, workSheet, sheetName)
      const wopts = {
        bookType: 'xlsx',
        bookSST: false,
        type: 'binary'
      }
      const wbBinaryData = XLSX.write(workBook, wopts)
      const wbBlob = new Blob([s2ab(wbBinaryData)], {
        type: 'application/octet-stream'
      })
      alignStyleProcess(wbBlob, outFileName, options).then(() => {
        resolve(true)
      }).catch((err) => {
        console.log(err)
        reject(new Error('file style add failed'))
      })
    }).catch((err) => {
      console.log(err)
      reject(new Error('File Export Failed！'))
    })
  })
}

export function MuiltExport (sheetArray, outFileName) {
  return new Promise((resolve, reject) => {
    import('xlsx').then((XLSX) => {
      const workBook = XLSX.utils.book_new()
      sheetArray.forEach((sheetData) => {
        const { data, mergeInfo, sheetName, options } = sheetData
        const workSheet = XLSX.utils.aoa_to_sheet(data, { raw: true })
        if (mergeInfo && mergeInfo.length) {
          workSheet['!merges'] = mergeInfo
        }
        if (options && options['!cols']) {
          workSheet['!cols'] = options['!cols']
        }
        if (options && options['!colFmt'] && options['!colFmt'].length) {
          const headRows = (options && options.headerRows) || 1
          const range = XLSX.utils.decode_range(workSheet['!ref'])
          const colFmts = options['!colFmt']
          colFmts.forEach((col) => {
            for (var row = range.s.r + headRows; row <= range.e.r; ++row) {
              var ref = XLSX.utils.encode_cell({ r: row, c: col.index })
              if (ref && workSheet[ref]) {
                workSheet[ref].t = col.dataType
                workSheet[ref].w = workSheet[ref].v
                workSheet[ref].z = '0'
              }
            }
          })
        }
        XLSX.utils.book_append_sheet(workBook, workSheet, sheetName)
      })
      const wopts = {
        bookType: 'xlsx',
        bookSST: false,
        type: 'binary'
      }
      const wbBinaryData = XLSX.write(workBook, wopts)
      const wbBlob = new Blob([s2ab(wbBinaryData)], {
        type: 'application/octet-stream'
      })
      MultiAlignStyleProcess(wbBlob, outFileName, sheetArray.map(t => t.options)).then(() => {
        resolve(true)
      }).catch((err) => {
        console.log(err)
        reject(new Error('file style add failed'))
      })
    }).catch((err) => {
      console.log(err)
      reject(new Error('File Export Failed！'))
    })
  })
}

function s2ab (s) {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i)
  return buf
}

function alignStyleProcess (wb, fileName, options) {
  const headerRows = (options && options.headerRows) || 1
  return new Promise((resolve, reject) => {
    import('xlsx-populate').then((module) => {
      module.default.fromDataAsync(wb).then((workbook) => {
        const defaultStyle = workbook.styleSheet().createStyle()
        defaultStyle.style('verticalAlignment', 'top')
        workbook.sheets().forEach((sheet) => {
          sheet.usedRange().forEach((cell, ri, ci) => {
            if (ri < headerRows) {
              cell.style({ bold: true, fill: 'C9C9C9', fontColor: '1F497D', border: 'thin' })
            } else {
              cell.style(defaultStyle)
            }
          })
          sheet.freezePanes(0, headerRows)
        })
        workbook.outputAsync().then((blob) => {
          const dataUrl = URL.createObjectURL(blob)
          downloadFile(dataUrl, fileName)
          resolve(true)
        }).catch(() => {
          reject(new Error('xlsx file save fail'))
        })
      }).catch((err) => {
        console.log(err)
        reject(new Error('xlsx file read error for style-add'))
      })
    }).catch(() => {
      reject(new Error('xlsx-populate load error'))
    })
  })
}

function MultiAlignStyleProcess (wb, fileName, options) {
  return new Promise((resolve, reject) => {
    import('xlsx-populate').then((module) => {
      module.default.fromDataAsync(wb).then((workbook) => {
        const defaultStyle = workbook.styleSheet().createStyle()
        defaultStyle.style('verticalAlignment', 'top')
        workbook.sheets().forEach((sheet, idx) => {
          const headerRows = (options[idx] && options[idx].headerRows) || 1
          sheet.usedRange().forEach((cell, ri, ci) => {
            if (ri < headerRows) {
              cell.style({ verticalAlignment: 'top', horizontalAlignment: 'center', bold: true, fill: 'C9C9C9', fontColor: '1F497D', border: 'thin' })
            } else {
              cell.style(defaultStyle)
            }
          })
          sheet.freezePanes(0, headerRows)
        })
        workbook.outputAsync().then((blob) => {
          const dataUrl = URL.createObjectURL(blob)
          downloadFile(dataUrl, fileName)
          resolve(true)
        }).catch(() => {
          reject(new Error('xlsx file save fail'))
        })
      }).catch(() => {
        reject(new Error('xlsx file read error for style-add'))
      })
    }).catch(() => {
      reject(new Error('xlsx-populate load error'))
    })
  })
}

function downloadFile (dataUrl, fileName) {
  const downloadAnchorNode = document.createElement('a')
  downloadAnchorNode.setAttribute('href', dataUrl)
  downloadAnchorNode.setAttribute('download', fileName)
  downloadAnchorNode.click()
  downloadAnchorNode.remove()
}
